import { gql } from '@apollo/client';

export const GetAccountOrganizationDetails = gql`
  query GetAccountOrganizationDetails($accountCode: String!) {
    account(accountCode: $accountCode) {
      code
      organization {
        name
        dateCreation
        owners {
          firstName
          lastName
        }
      }
    }
  }
`;
